module.exports = __webpack_public_path__ + "static/cleo-7d2b6b8be6658976b77c73760217d523.jpg";